import { Checkbox, Dialog, Flex, TextInput } from '@leverege/ui-elements'
import React, { useCallback, useState } from 'react'

export default function AddIntentDialog( props ) {
  const { show, onClose, onAddIntent : pOnAddIntent, template } = props

  const [ intentKey, setIntentKey ] = useState()
  const [ hasSubject, setHasSubject ] = useState( false )

  const onSetHasSubject = useCallback( ( { value } ) => {
    setHasSubject( value )
  }, [] )

  const onSetIntentKey = useCallback( ( { value } ) => {
    setIntentKey( value )
  }, [] )
  const onAddIntent = useCallback( () => {
    pOnAddIntent( { intentKey, hasSubject } )
    onClose()
  }, [ pOnAddIntent, intentKey, onClose, hasSubject ] )

  const [ isValid, setIsValid ] = useState( true )
  const validator = useCallback( ( value ) => {
    const isValid = value != null && value?.trim() !== '' && !template?.intents?.[value]
    setIsValid( isValid )

    return isValid
  }, [ template ] )

  return (
    <Dialog.Question
      show={show}
      onClose={onClose}
      onOkay={onAddIntent}
      onCancel={onClose}
      okayDisabled={!isValid}
      okay="Add Intent">
      <Flex variant="colM">
        <TextInput
          autoFocus
          validator={validator}
          variant="fullWidth"
          hint='Intent Key (e.g. "email", "sms")'
          value={intentKey}
          onChange={onSetIntentKey} />
        <Checkbox
          label="Has Subject?"
          onChange={onSetHasSubject}
          value={hasSubject} />
      </Flex>
    </Dialog.Question>
  )
}
